import React, { useState } from 'react';
import styled from 'styled-components';
import { Button, token } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';

import { HelpModal } from './HelpModal';
import { track } from '../../../helpers/track';

export function HelpButton() {
	const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);
	const { translate } = useTranslate();

	const openHelpModal = () => {
		track('Spotlight Help Modal Opened', {
			product_category: 'Spotlight',
			functional_area: 'Search',
		});
		setIsHelpModalOpen(true);
	};

	const closeHelpModal = () => {
		track('Spotlight Help Modal Closed', {
			product_category: 'Spotlight',
			functional_area: 'Search',
		});

		setIsHelpModalOpen(false);
	};

	return (
		<>
			<FooterContainer>
				<Button variant="secondary" isSmall onClick={() => openHelpModal()}>
					{translate('spotlightHelp.title')}
				</Button>
			</FooterContainer>

			<HelpModal isOpen={isHelpModalOpen} onClose={() => closeHelpModal()} />
		</>
	);
}

const FooterContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	margin: ${token.spacing4};
	margin-top: ${token.spacing3};
`;
